// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"df7efde1","952":"e1550def"}[chunkId] + ".chunk.js";
};